import { useRef } from "react";
import { useLang } from "@/i18n/LanguageContext";

// أداة اختيار صورة: رفع من الجهاز أو التقاط من كاميرا الجهاز (native)
export default function ImagePicker({ onImage, testIdPrefix = "picker" }) {
  const uploadRef = useRef(null);
  const cameraRef = useRef(null);
  const { t } = useLang();

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => onImage(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  return (
    <div className="flex gap-3">
      <input ref={uploadRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testIdPrefix}-upload-input`} />
      <input ref={cameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handleFile} data-testid={`${testIdPrefix}-camera-input`} />
      <button
        onClick={() => cameraRef.current?.click()}
        data-testid={`${testIdPrefix}-open-camera`}
        className="flex-1 glass glass-blue rounded-2xl py-3 flex items-center justify-center gap-2 text-sm text-ai hover:brightness-125 transition"
      >
        <i className="fa-solid fa-camera" /> {t("openCamera")}
      </button>
      <button
        onClick={() => uploadRef.current?.click()}
        data-testid={`${testIdPrefix}-upload`}
        className="flex-1 glass gold-border rounded-2xl py-3 flex items-center justify-center gap-2 text-sm text-gold hover:brightness-125 transition"
      >
        <i className="fa-solid fa-image" /> {t("uploadImage")}
      </button>
    </div>
  );
}
